import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

const messages: {
	[key: string]: MessageDescriptor;
} = defineMessages({
	tooltip: {
		id: 'issue-create-commons.create-work-video-education-modal-trigger-button.tooltip',
		defaultMessage: 'Watch a tutorial on how to create work',
		description: 'Tooltip for create work video education modal trigger button',
	},
});

export default messages;
